"use strict";
/**
 * Firebase Firestore Collection Constants
 *
 * Centralized collection name constants to avoid hardcoded strings
 * and maintain consistency across the application.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIREBASE_COLLECTIONS = void 0;
exports.FIREBASE_COLLECTIONS = {
    AFFILIATES: "affiliates",
    AIRTIME_PURCHASES: "airtimePurchases",
    AIRTIME_PRODUCT_MAPPING: "airtime_product_mapping",
    BRANCHES: "branches",
    CHATS: "chats",
    DEVICE_SALES_AGREEMENTS: "deviceSalesAgreements",
    HOME_CONTENT: "homeContent",
    LAY_BUYS: "lay_buys",
    LOAN_APPLICATIONS: "loan_applications",
    PEP_PIP_ADV_PROFILE: "pep_pip_adv_profile",
    PROVIDERS: "providers",
    PUBLICATIONS: "publications",
    USERS: "users",
};
